"use client";

import clsx from "clsx";
import React from "react";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";

const InfoModal = ({
  isOpen,
  onClose,
  title,
  marginX,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  marginX?: "mx-[84px]";
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={clsx(` mb-5 mt-[72px] flex flex-col items-center`, marginX)}>
        <div className="item-center mb-[80px] flex items-center justify-center">
          <p className="text-[20px]">{title}</p>
        </div>
        <Button style={ButtonStyle.OUTLINE} onClick={onClose} text="閉じる" width="w-[160px]" />
      </div>
    </Modal>
  );
};

export default InfoModal;
